module.exports = __webpack_public_path__ + "img/the-end-main.9f4da45d.png";